import React from 'react';
import {useRouteMatch} from 'react-router-dom';

import {Nav} from 'reactstrap';

import PrivateNavPlan from './PrivateNavPlan';
import PrivateNavUser from './PrivateNavUser';
import PrivateNavLimit from './PrivateNavLimit';
import PrivateNavSearch from './PrivateNavSearch';
import PrivateNavNotification from './PrivateNavNotification';
import PrivateNavAnnouncements from './PrivateNavAnnouncements';

import {useAuth} from 'contexts/AuthContext';
import {useLimits} from 'contexts/LimitsContext';
import {usePage} from 'contexts/PageContext';

import {debounce, get, isEqual} from 'lodash';
import styles from './styles.module.scss';

import {ACCOUNT_ROLES, COMPANY_TYPES, COMPANY_STATUSES} from 'configs';
import {useMembership} from 'contexts/MembershipContext';
import {
  SUBSCRIPTION_BILLING_METHOD,
  SUBSCRIPTION_TYPE_LEVEL,
} from 'configs/membership';
import MuiIcon from 'components/Icons/MuiIcon';

function PrivateNav(props) {
  const {dark, search, upgrade, isMobile} = props;
  const {setSidebar, isOpenLeftSidebar, sidebar} = usePage();
  const isAdvancedSearch = useRouteMatch('/advanced-search');

  const auth = useAuth();
  const {data, isLoading: isLoadingLimits} = useLimits();
  const isSuperAdmin =
    get(auth, 'account.account_role') === ACCOUNT_ROLES.super_admin;

  const isCompany = get(auth, 'isCompany');
  const accountType = get(auth, 'companyType');
  const {isLegacyUser} = useMembership();
  const isCE = accountType === COMPANY_TYPES.ce;

  const isVU = isCE || isCompany;

  const isCompanySuspended =
    get(auth, 'account.company.company_status') === COMPANY_STATUSES.suspended;

  const toggleSidebar = debounce(() => {
    setSidebar('left', !isOpenLeftSidebar, true);
  }, 100);

  const {
    isSubscribed,
    subscriptionLevel,
    billingMethod,
    isSuspendedSubscription,
  } = useMembership();
  const showLimits =
    subscriptionLevel > SUBSCRIPTION_TYPE_LEVEL.free &&
    subscriptionLevel < SUBSCRIPTION_TYPE_LEVEL.enterprise;

  const {available_limit_left, company_available_limit_left} = data;

  const isManualMethod = isEqual(
    billingMethod,
    SUBSCRIPTION_BILLING_METHOD.manual
  );

  const limitLeft = isLegacyUser
    ? available_limit_left
    : company_available_limit_left;

  const showNavLimits =
    ((limitLeft >= 0 && isLegacyUser) || (limitLeft > 0 && !isLegacyUser)) &&
    isSubscribed &&
    showLimits &&
    !isLoadingLimits &&
    !get(data, 'overlimit_reached');

  const showNavPlan =
    isSuperAdmin &&
    subscriptionLevel !== 10 &&
    !isManualMethod &&
    !isSuspendedSubscription;

  return (
    <>
      {!!sidebar && (
        <span
          onClick={toggleSidebar}
          className="d-xl-none p-1 ml-2 text-primary cursor-pointer"
        >
          <MuiIcon name="menu" />
        </span>
      )}
      <div className={styles['private__nav__search__container']}>
        {!isCompanySuspended && search && !isAdvancedSearch && (
          <PrivateNavSearch hasSidebar={!!sidebar} isMobile={isMobile} />
        )}
      </div>

      <Nav className="align-items-center ml-auto flex-row" navbar>
        {isVU && !!upgrade && (
          <>
            {showNavLimits && <PrivateNavLimit />}
            {showNavPlan && <PrivateNavPlan />}
          </>
        )}

        <PrivateNavNotification dark={dark} />

        {isVU && <PrivateNavAnnouncements />}

        <PrivateNavUser />
      </Nav>
    </>
  );
}

export default PrivateNav;
